<template>
  <el-dialog
    :title="$t('dialog.titlePeriod')"
    :visible="isShow"
    :close-on-click-modal="false"
    append-to-body
    width="600px"
    @close="onClose"
  >
    <div class="das-form-container">
      <validation-observer ref="formValidator">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">{{ $t('field.periodCode') }}</div>
                <validation-provider
                  rules="required|max:20|no_special"
                  :name="$t('field.periodCode')"
                >
                  <input
                    v-model="formData.code"
                    type="text"
                    @input="
                      e => {
                        formData.code = e.target.value
                      }
                    "
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">{{ $t('field.period') }}</div>
                <!-- <validation-provider rules="required" name="Giai đoạn"> -->
                <div class="input-group">
                  <div class="input-group__prepend">
                    {{ priceCodeName }}
                  </div>
                  <input v-model="formData.code" type="text" readonly />
                </div>
                <!-- </validation-provider> -->
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">{{ $t('field.fromDate') }}</div>
                <validation-provider
                  rules="required"
                  :name="$t('field.fromDate')"
                >
                  <SingleCalendar
                    v-model="formData.date_from"
                    class="use-icon"
                    @input="onChangeDateFrom"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">{{ $t('field.toDate') }}</div>
                <validation-provider
                  rules="required"
                  :name="$t('field.toDate')"
                >
                  <SingleCalendar
                    v-model="formData.date_to"
                    class="use-icon"
                    @input="onChangeDateTo"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">{{ $t('field.desc') }}</div>
                <validation-provider rules="max:255" :name="$t('field.desc')">
                  <textarea v-model="formData.desc" rows="2"></textarea>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
    <div style="gap: 10px" class="mb-10 flex justify-end">
      <button class="btn primary small outline" @click="onClickUpdateBtn">
        {{ $t('button.update') }}
      </button>
      <button class="btn primary small" @click="onClickAddBtn">
        {{ $t('button.add') }}
      </button>
      <!-- <el-button type="primary" @click="onClickAddBtn">Thêm</el-button>
      <el-button type="primary" @click="fnSubmit">Cập nhật</el-button> -->
    </div>

    <div style="height: 300px; padding-bottom: 20px">
      <GridVx
        ref="priceCodeGrid"
        v-loading="gridLoading"
        dom-layout="scroll"
        :columns="priceByLevelCols"
        :rows="priceByLevelRows"
        :auto-select-first-row="false"
        row-selection="single"
        class="agGrid"
        @selectionChanged="onSelectRow"
      />
    </div>
  </el-dialog>
</template>

<script>
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import {
  addPricePyLevelApi,
  editPriceByLevelApi,
  getPriceByLevelList
} from '@/api/Service_Policy/priceCode'

import { isArrayItemUnique, isDateRangesUnique } from '@/utils/commonUtils'
import { dehydrateFields } from '@/utils/form'
export default {
  components: {
    SingleCalendar
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    priceByLevelList: {
      type: Array,
      default: () => []
    },
    priceCodeId: {
      type: [Number, String]
    },
    priceCodeName: {
      type: String
    },
    isEditDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        id: null,
        code: null,
        price_code_id: null,
        date_from: null,
        date_to: null,
        desc: null
      },
      priceByLevelRows: [],
      priceByLevelCols: [
        {
          headerName: this.$t('grid.column.periodCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          flex: 1
          // width: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          // cellClass: 'grid-cell-centered',
          // flex: 1,
          width: 200
        },
        {
          headerName: this.$t('grid.column.fromDate'),
          field: 'date_from',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          width: 100,
          maxWidth: 120
        },
        {
          headerName: this.$t('grid.column.toDate'),
          field: 'date_to',
          // cellClass: 'grid-cell-centered',
          flex: 1,
          width: 100,
          maxWidth: 120
        }
      ],
      isEdit: false,
      gridLoading: false
    }
  },
  watch: {
    priceByLevelList: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.isShow) {
          this.fnSetPriceLevelRows()
        }
      }
    },
    isShow: {
      handler(val) {
        if (val) {
          this.fnSetPriceLevelRows()
        } else {
          this.fnResetForm()
        }
      }
    }
  },
  methods: {
    checkDatesValid(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        return false
      }

      return true
    },
    onChangeDateFrom(date) {
      this.formData.date_from = date
      if (!this.checkDatesValid(date, this.formData.date_to)) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.saleStartDateMustBeforeEnd')
        })
        this.formData.date_to = this.$moment(date).add(1, 'd').toDate()
      }
    },
    onChangeDateTo(date) {
      this.formData.date_to = date
      if (!this.checkDatesValid(this.formData.date_from, date)) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.saleStartDateMustBeforeEnd')
        })
        this.formData.date_to = this.$moment(this.formData.date_from)
          .add(1, 'd')
          .toDate()
      }
    },

    onSelectRow(rows) {
      const rowData = rows[0]
      if (rowData) {
        this.isEdit = true
        this.formData = {
          ...rowData
        }
      } else {
        this.fnResetForm()
      }
    },

    fnResetForm() {
      this.formData = {
        id: null,
        code: null,
        price_code_id: null,
        date_from: null,
        date_to: null,
        desc: null
      }
      this.$nextTick(() => {
        this.$refs.formValidator.reset()
      })
    },

    fnSetPriceLevelRows() {
      /** If priceCodeId exist -> get list by sending request
       * Else -> get list from props
       */
      if (this.priceCodeId && this.isEditDialog) {
        this.fnGetPriceByLevelList({ isEmit: false })
      } else {
        this.priceByLevelRows = [...this.priceByLevelList]
      }
    },

    async fnAddPriceByLevel() {
      this.formData.id = null
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      // Add priceByLevel to existed Price Code
      if (this.priceCodeId && this.isEditDialog) {
        const payload = {
          ...this.formData,
          price_code_id: this.priceCodeId
        }
        try {
          const res = await addPricePyLevelApi(payload)
          if (res?.message) {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + res.message)
            })
          }
          await this.fnGetPriceByLevelList({ isEmit: true })
          this.fnResetForm()
        } catch (err) {
          this.$message({
            type: 'error',
            message: this.$t(
              err?.response?.data?.message
                ? 'errorMsg.' + err.response.data.message
                : 'errorMsg.default'
            )
          })
        }
      } else {
        const tmpPriceByLevelList = [
          ...this.priceByLevelRows,
          this.formData
        ].map(item => ({
          code: item.code,
          startDate: item.date_from,
          endDate: item.date_to
        }))
        if (!isArrayItemUnique(tmpPriceByLevelList, 'code')) {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.stageCodeIsDuplicated')
          })
        } else if (!isDateRangesUnique(tmpPriceByLevelList)) {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.periodCannotOverlap')
          })
        } else {
          this.priceByLevelRows.push(this.formData)
          this.$emit('updatePriceByLevelList', this.priceByLevelRows) // ONLY emit when add new price code
          // this.priceByLevelRows = [...this.priceByLevelRows, this.formData]
          this.fnResetForm()
        }

        // Add priceByLevel to new Price Code
        return
      }
    },

    async fnEditPriceByLevel() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      // Update priceByLevel in existed Price Code
      if (this.priceCodeId && this.isEditDialog) {
        const payload = {
          ...this.formData,
          price_code_id: this.priceCodeId
        }
        await editPriceByLevelApi(payload)
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('successMsg.' + res.message)
            })
            this.fnGetPriceByLevelList({ isEmit: true })
            this.fnResetForm()
          })
          .catch(err => {
            this.$message({
              type: 'error',
              message: this.$t('errorMsg.' + err.response.data.message)
            })
          })
      } else {
        // Update priceByLevel in new Price Code
        const gridApi = this.$refs.priceCodeGrid.gridApi
        const selectedNode = gridApi.getSelectedNodes()[0]

        // Create new list variables for validating
        let tmpPriceByLevelList = this.priceByLevelRows.filter(
          (_, index) => index !== selectedNode.rowIndex
        )
        tmpPriceByLevelList = [...tmpPriceByLevelList, this.formData].map(
          item => ({
            code: item.code,
            startDate: item.date_from,
            endDate: item.date_to
          })
        )

        // Check if price code existed
        if (!isArrayItemUnique(tmpPriceByLevelList, 'code')) {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.stageCodeIsDuplicated')
          })
        } else if (!isDateRangesUnique(tmpPriceByLevelList)) {
          // Check if period overlap

          this.$message({
            type: 'error',
            message: this.$t('errorMsg.periodCannotOverlap')
          })
        } else {
          selectedNode.setData(this.formData)
          this.priceByLevelRows[selectedNode.rowIndex] = this.formData
          this.$emit('updatePriceByLevelList', this.priceByLevelRows)
          this.fnResetForm()
          // After editing -> Return isEdit flag to false
          this.isEdit = false
        }
      }
    },

    /**
     * @param {boolean} isEmit - Emit priceByLevelRows after fetch if true
     */
    async fnGetPriceByLevelList({ isEmit }) {
      this.gridLoading = true
      getPriceByLevelList({ priceCodeId: this.priceCodeId })
        .then(res => {
          this.priceByLevelRows = res.data
          if (isEmit) {
            this.$emit('updatePriceByLevelList', this.priceByLevelRows)
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },

    // ACTIONS
    async onClose() {
      dehydrateFields(this.formData)
      await this.$refs.formValidator.validateWithInfo()
      if (this.$refs.formValidator.flags.changed) {
        this.$vxConfirm(this.$t('alert.periodNotSavedExitConfirm'), {
          resolveText: this.$t('button.exit'),
          rejectText: this.$t('button.stay'),
          resolve: () => {
            this.$emit('close')
          }
        })
      } else {
        this.$emit('close')
      }
    },
    onClickAddBtn() {
      if (this.isEdit) {
        this.isEdit = false
        this.formData = {
          id: null,
          code: null,
          price_code_id: this.priceCodeId,
          date_from: null,
          date_to: null,
          desc: null
        }
      } else {
        this.$message(this.$t('infoMsg.clickUpdateForSaving'))
      }
    },
    onClickUpdateBtn() {
      this.isEdit ? this.fnEditPriceByLevel() : this.fnAddPriceByLevel()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 10px !important;
}
</style>
